import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {

  constructor(private http:HttpClient) { }

  addPushNotification(data:any) {
    return this.http.post(`${environment.apiUrl}notificationsetting`,data);
  }

  updatePushNotification(id:string,data:any) {
    return this.http.put(`${environment.apiUrl}notificationsetting/${id}`,data);
  }

  getPushNotificationById(id:string) {
    return this.http.get(`${environment.apiUrl}notificationsetting/${id}`);
  }

  getAllPushNotification(query:string) {
    return this.http.get(`${environment.apiUrl}notificationsetting${query}`);
  }

  addBulkNotification(data) {
    return this.http.post(`${environment.apiUrl}bulk-notification`,data);
  }

  updateBulkNotification(id,data) {
    return this.http.put(`${environment.apiUrl}bulk-notification/${id}`,data);
  }

  getBulkNotification(query:string) {
    return this.http.get(`${environment.apiUrl}bulk-notification?${query}`);
  }

  getBulkNotificationById(id:string) {
    return this.http.get(`${environment.apiUrl}bulk-notification/${id}`);
  }

}
